import axios from "axios";

export const key = "AX009XWKLMO450SHJEKAZEI";
export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});